<template>
    <div class="sec_banner" :class="bannerList.length <= 1 ? 'hiddenSlides' : ''">
        <el-carousel
            :arrow="(bannerList && bannerList.length) > 1 ? 'hover' : 'never'"
            height="330px"
            v-if="bannerList.length > 0"
        >
            <el-carousel-item
                class="banner-item"
                v-for="{ id, file_url, target_type, target_url } in bannerList"
                :key="id"
            >
                <div class="banner-wrapper" @click="getBannerUrl(target_type, target_url, id)">
                    <img
                        class="banner-img"
                        :src="
                            $utils.toThumbnail(file_url, null, 330, 'm_lfit') ||
                                require('../../../assets/images/banner .png')
                        "
                    />
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
export default {
    created() {
        this.getBanners()
    },
    data() {
        return { bannerList: [] }
    },
    methods: {
        async getBanners() {
            const bannerList = await this.$http.getBannerList()
            this.bannerList = bannerList
        },
        getBannerUrl(target_type, target_url, id) {
            if (!target_url) return
            switch (target_type) {
                case 1:
                case 3:
                    target_url && window.open(target_url)
                    break
                case 2:
                    window.location.href = `/${$schoolUrl}/bannerDetail.html?bannerCon=${id}`
                default:
                    break
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.sec_banner {
    width: 100%;
    height: 330px;
    border-radius: 0;
    z-index: 1;
}
.banner-item {
    .banner-wrapper {
        // width: 1920px;
        width: 100%;
        height: 330px;
        // height: 100%;
    }
    .banner-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.sec_banner.hiddenSlides {
    :deep(.el-carousel__indicators) {
        display: none;
    }
}
// @media only screen and (min-width: 1920px) {
//     .sec_banner {
//         width: 1920px;
//     }
// }
</style>
